// Clients « Type » filter. A record both Meunerie and Entreprise facturée counts in both types.
export const CLIENT_TYPE_URL_PARAM = "client_type";

export const CLIENT_TYPE_OPTIONS = Object.freeze([
  { value: "all", label: "Tous" },
  { value: "meunerie", label: "Meuneries" },
  { value: "coop", label: "Entreprises facturées" },
  { value: "other", label: "Autres" },
]);

export function resolveClientTypeFilter(value) {
  return CLIENT_TYPE_OPTIONS.some((option) => option.value === value) ? value : "all";
}

export function matchesClientType(entry, type) {
  if (type === "meunerie") {
    return Boolean(entry?.is_meunerie);
  }
  if (type === "coop") {
    return Boolean(entry?.is_coop);
  }
  if (type === "other") {
    return !entry?.is_meunerie && !entry?.is_coop;
  }
  return true;
}

export function countClientTypes(entries) {
  const rows = Array.isArray(entries) ? entries : [];
  return Object.fromEntries(CLIENT_TYPE_OPTIONS.map((option) => [
    option.value,
    rows.filter((entry) => matchesClientType(entry, option.value)).length,
  ]));
}
